/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Link, typography2 } from '@coursera/cds-core';
import type { PageTabName } from '@coursera/event-pulse-types';
import { useTracker } from '@coursera/event-pulse/react';

export type Props = {
  trackingName?: PageTabName;
  label?: string;
  href?: string;
  isCurrent?: boolean;
  name?: string;
};

const styles = {
  link: css`
    // chaining the selectors to override CDS styles
    &&& {
      display: block;
      white-space: nowrap;
      padding: var(--cds-spacing-100);
      color: var(--cds-color-neutral-primary-weak);
      text-decoration: none;
      ${typography2.bodySecondary}

      :hover {
        color: var(--cds-color-interactive-primary);
      }

      :focus {
        outline: 5px auto -webkit-focus-ring-color;
        outline-offset: -2px;

        /* override box-shadow from .cds-link-focusVisible */
        box-shadow: none !important;
      }
    }
  `,
  currentLink: css`
    font-weight: bold;
    color: var(--cds-color-interactive-primary);
    border-bottom: 4px solid var(--cds-color-interactive-primary);
  `,
};

const NavLinkGridItem = ({ label, href, isCurrent, name, trackingName }: Props) => {
  const track = useTracker();

  return (
    <Grid item>
      <Link
        href={href}
        variant="quiet"
        css={[styles.link, isCurrent && styles.currentLink]}
        {...(isCurrent ? { 'aria-current': 'page' } : {})}
        data-testid={`nav-link-grid-item-${name ?? href}`}
        onClick={() => {
          track('click_page_tab', { pageTab: { name: trackingName } });
        }}
      >
        {label}
      </Link>
    </Grid>
  );
};

export default NavLinkGridItem;
